import { RadioGroup } from '@mui/material';
import { BaseRadioGroupProps } from './BaseRadioGroup.types';

/**
 * The base `RadioGroup` control from  MUI that we use to wrap off of
 * for our own controls. This is used to create separation so we can use jest to mock it.
 *
 * @param classes - {@link BaseRadioGroupProps.classes classes} description.
 * @param ariaLabel - {@link BaseRadioGroupProps.ariaLabel ariaLabel} description.
 * @param name - {@link BaseRadioGroupProps.name name} description.
 * @param value - {@link BaseRadioGroupProps.value value} description.
 * @param onChange - {@link BaseRadioGroupProps.onChange onChange} description.
 * @param children - {@link BaseRadioGroupProps.children children} description.
 */
export const BaseRadioGroup = ({
    classes,
    ariaLabel,
    name,
    value,
    onChange,
    children,
}: BaseRadioGroupProps) => {
    return (
        <RadioGroup
            classes={{
                ...classes,
            }}
            aria-label={ariaLabel}
            name={name}
            value={value}
            onChange={onChange}
        >
            {children}
        </RadioGroup>
    );
};